export default "__VITE_ASSET__D1yJ00wz__"